<template>
    <empty-table-message v-if="isEmpty" />
    <div class="bg p-1 calendar-container" v-else>
        <vue-cal
            ref="vuecal"
            locale="pt-br"
            active-view="month"
            :min-date="minDate"
            :max-date="maxDate"
            today-button
            :events="events"
            :time="showTime"
            :on-event-click="onEventClick"
            show-time-in-cells
            events-on-month-view="short"
            resize-x
            :min-event-width="70"
            :timeCellHeight="100"
            :on-event-create="onEventCreate"
            @event-drag-create="criarEvento()"
            :editable-events="{
                title: false,
                drag: false,
                resize: false,
                delete: false,
                create: true,
            }"
            eventsCountOnYearView
        >
            <template #event="{ event, view }">
                <div class="vuecal__event-title">
                    {{ event.title }}
                    <br />
                    <small>
                        <span
                            v-if="event.evento != undefined && !isLoading"
                            class="icon"
                            :style="{
                                color:
                                    event.evento.crmAgenda.tipoAgendaAtividade.cor != null
                                        ? event.evento.crmAgenda.tipoAgendaAtividade.cor
                                        : 'silver',
                            }"
                            :title="event.evento.crmAgenda.tipoAgendaAtividade.descricao"
                        >
                            <i
                                :class="
                                    event.evento.crmAgenda.tipoAgendaAtividade.icone != null
                                        ? event.evento.crmAgenda.tipoAgendaAtividade.icone.toLowerCase()
                                        : 'fas fa-calendar'
                                "
                            />
                        </span>
                        {{ event.start.formatTime() }} -
                        {{ event.end.formatTime() }}
                        <div v-if="event.evento.crmAgenda.idCliente != 0">
                            {{
                                event.evento.crmAgenda.cliente != undefined
                                    ? event.evento.crmAgenda.cliente.nome
                                    : ''
                            }}
                        </div>
                    </small>
                </div>
            </template>
        </vue-cal>
    </div>
</template>

<script>
// https://antoniandre.github.io/vue-cal/
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

export default {
    name: 'AgendaListCalendar',
    components: {
        VueCal,
    },
    props: {
        minDate: {
            type: Date,
            default: (_) => new Date().subtractDays(10),
        },
        maxDate: {
            type: Date,
            default: (_) => new Date().addDays(10),
        },
        isLoading: {
            type: Boolean,
            default: true,
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        events: {
            type: Array,
            default: (_) => [
                // {
                //     class: 'primary',
                //     start: '2023-10-19 14:00',
                //     end: '2023-10-19 15:00',
                //     title: 'title',
                //     content: '',
                // },
            ],
        },
    },
    data() {
        return {
            showTime: true,
            selectedEvent: null,
        };
    },
    methods: {
        onEventClick(event, e) {
            this.$emit('showModalAgendaManage', true);
            this.$emit('uuidAgendaManage', event.evento.uuid);

            // Prevent navigating to narrower view (default vue-cal behavior).
            e.stopPropagation();
        },

        onEventCreate(event, deleteEventFunction) {
            this.selectedEvent = event;
            this.deleteEventFunction = deleteEventFunction;

            return event;
        },
        criarEvento() {
            this.$emit('new', { start: this.selectedEvent.start, end: this.selectedEvent.end });
            this.deleteEventFunction();
            this.selectedEvent = null;
        },
    },
};
</script>
<style lang="scss">
.calendar-container {
    height: 100%;
    .icon {
        background-color: #fff;
        border-radius: 3px;
        margin-bottom: 2px;
    }
}
.vuecal {
    height: 100%;
    .vuecal__cell {
        text-align: left;
    }
    .cell-time-label,
    .vuecal__cell-date {
        text-align: center;
    }
    .vuecal__event {
        border: solid 1px $table-border;
        border-radius: 3px;
        cursor: pointer;
        padding-left: 3px;
        margin-bottom: 1px;
        &.bar-finalizada {
            border-left-color: #84bd42;
            border-left-width: 5px;
        }
        &.bar-aberta {
            border-left-color: #fd5858;
            border-left-width: 5px;
        }
    }
    .vuecal__event-title {
        text-transform: lowercase;
    }
    .vuecal__cell--today {
        box-shadow: 0 0 4px 5px rgba(224, 224, 224, 0.5) inset;
    }
    .vuecal__cell--selected {
        box-shadow: 0 0 4px 5px rgba(224, 224, 224, 0.5) inset;
    }
}
</style>
